import moment from "moment";
import { IDeliveryBoardItem } from "../../common/interfaces";

// Textos y colores del tablero de domicilios.
export const KITCHEN: Record<string, { text: string; color: string }> = {
  scheduled: { text: "Programado", color: "#5b8def" },
  preparing: { text: "Preparando", color: "#ff9800" },
  ready: { text: "Listo", color: "#239e2e" },
  delivered: { text: "Entregado", color: "#239e2e" },
};

export const FLAGS: Record<string, string> = {
  no_code: "Sin código",
  code_mismatch: "Código no coincide",
  far_from_address: "Lejos del domicilio",
  sin_evidencia: "Sin evidencia",
};

export const REASONS: Record<string, string> = {
  no_contesta: "No contesta",
  direccion_incorrecta: "Dirección incorrecta",
  rechazo: "Rechazó el pedido",
  otro: "Otro motivo",
};

export const money = (n: number | null | undefined) =>
  `$${Number(n || 0).toLocaleString("es-MX", { minimumFractionDigits: 2, maximumFractionDigits: 2 })}`;

export const minutesSince = (iso: string | null) => (iso ? Math.max(0, moment().diff(moment(iso), "minutes")) : null);

export const elapsedText = (iso: string | null) => {
  const m = minutesSince(iso);
  if (m === null) return "";
  return m < 60 ? `${m} min` : `${Math.floor(m / 60)} h ${m % 60} min`;
};

// La ETA (texto y hora) la arma el back en DeliveryEta; aquí sólo se muestra.
export const etaText = (d: IDeliveryBoardItem) => (d.eta ? `llega en ${d.eta.text} (${moment(d.eta.arrives_at).format("HH:mm")})` : null);
